import { Failure, Ok } from "@megarax/fp";
import { serializerExtensions, SerializerExtensions } from "../extensions";
import { Serializer } from "../serializer";
import { identity } from "./object";

export const result = <TValue, TError = never>(
  successSerializer: Serializer<TValue> = identity(),
  failureSerializer: Serializer<TError> = identity(),
): Serializer<Ok<TValue> | Failure<TError>> &
  SerializerExtensions<Ok<TValue> | Failure<TError>> => ({
  serialize: (input) => {
    if (input.isOk)
      return {
        isOk: true,
        value: successSerializer.serialize(input.value),
      };
    else
      return {
        isOk: false,
        error: failureSerializer.serialize(input.error),
      };
  },
  deserialize: (raw) => {
    if (raw.isOk) return Ok(successSerializer.deserialize(raw.value));
    else return Failure(failureSerializer.deserialize(raw.error));
  },
  ...serializerExtensions(),
});
